module.exports = __webpack_public_path__ + "static/media/check.b00b5a17.svg";